import CampaignsLoading from "V2.0/HomePages/HomeCampaign/common/CampaignLoading";
import BulkCampaign from "./BulkCampaign";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

const bulkCampaignDownloadLifecycleCbs = {
  init: (name) => {
    const loadingText = name ? `Downloading ${name}` : "Downloading";
    message.loading(loadingText);
  },
  success: (filename, campaignName) => {
    message.destroy();
    message.success(`Downloaded ${campaignName} to ${filename}.csv`);
  },
  error: (e) => {
    message.destroy();
    showErrorToast(e, "Failed to download");
  },
};

export default function BulkCampaignsTable(props) {
  const {
    bulkCampaigns,
    isLoading,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly,
  } = props;

  if (isLoading) {
    return <CampaignsLoading />;
  }

  return (
    // Old wrapper: "flex flex-col gap-y-4 p-2 h-full min-h-0 flex-1 overflow-scroll w-full" — owned
    // its own scroll region. Replaced with Frontend's tighter wrapper since the new
    // BulkCampaignTableHeader/tabs container (Task 4/8) now owns the scroll region instead.
    // (bulk-campaign-report-ui-port, Task 8 Step 3)
    // <div className="flex flex-col gap-y-4 p-2 h-full min-h-0 flex-1 overflow-scroll w-full">
    <div className="flex flex-col divide-y divide-zinc-100 w-full">
      {bulkCampaigns.map((bulkCampaign, idx) => {
        return (
          <div key={idx}>
            <BulkCampaign
              bulkCampaign={bulkCampaign}
              onBulkCampaignClick={() => onBulkCampaignClick(bulkCampaign)}
              onBulkCampaignDelete={(e) => {
                e.stopPropagation();
                onBulkCampaignDelete(bulkCampaign);
              }}
              onBulkCampaignReport={(e) => {
                e.stopPropagation();
                onBulkCampaignReport(bulkCampaign)
              }}
              onBulkCampaignDownload={(e) => {
                e.stopPropagation();
                onBulkCampaignDownload(
                  bulkCampaign,
                  bulkCampaignDownloadLifecycleCbs,
                );
              }}
              onBulkCampaignResume={(e) => {
                e.stopPropagation();
                onBulkCampaignResume(bulkCampaign);
              }}
              onBulkCampaignPause={(e) => {
                e.stopPropagation();
                onBulkCampaignPause(bulkCampaign);
              }}
              onBulkCampaignCancel={(e) => {
                e.stopPropagation();
                onBulkCampaignCancel(bulkCampaign);
              }}
              isViewOnly={isViewOnly}
            />
          </div>
        );
      })}
    </div>
  );
}
